/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { A as index$5 } from '../../index-e5fa4dec.js';
import { extend } from '../extend/index.js';
import scan$3 from './cn/index.js';
import scan$4 from './cnStation/index.js';
import scan$5 from './tbLive/index.js';
import scan$1 from './dingTalk/index.js';
import scan$2 from './nebula/index.js';
import '../../tslib.es6-e01eabb2.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../../index-892d8eee.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';

// api: https://uni-apis.alibaba-inc.com/doc/UI/scan
var apiConfig = {
    web: {
        dingTalk: scan$1,
        nebula: scan$2,
        windvane: {
            cn: scan$3,
            cnStation: scan$4,
            tbLive: scan$5,
        },
    },
};
/**
 * 扫一扫。API：https://yuque.antfin.com/cn-xt/arch/lwbvd0
 * 支持淘宝、支付宝、菜鸟裹裹、驿站掌柜App等端。支持度一览表：https://yuque.antfin.com/cn-xt/arch/isxm98
 * @param  {ScanIOptions} config 扫一扫参数
 * @returns {Promise<{ code: string } & unknown>} promise调用结果
 * @example 使用案例：
 * import { scan } from '@alife/cn-uni-api';
 * try {
 *    const res = await scan();
 *    console.log('扫码结果', res.code ?? res.qrCode)
 * } catch(e) {
 *    console.log('扫一扫失败', e);
 * }
 * @author 敬文
 */
var scan = extend(apiConfig, index$5);

export { scan };
